import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SvgIcons } from '@niceltd/cxone-components/shared-services';

@Component({
    selector: 'cv-embedded-messages',
    templateUrl: './embedded-messages.component.html',
    styleUrls: ['./embedded-messages.component.scss']
})
export class EmbeddedMessagesComponent implements OnInit {

    @Input() embeddedMessageId: string;
    @Input() messageType: string;
    @Input() messageData: string;
    @Input() messageLink: string;
    @Output() linkClicked: EventEmitter<void> = new EventEmitter<void>();

    icon: SafeHtml;
    private svgIcons = new SvgIcons(this.sanitizer);
    constructor(private sanitizer: DomSanitizer) { }

    ngOnInit(): void {
        this.icon = this.svgIcons.getSvgIcons(this.messageType);
    }

    onLinkClick(): void {
        this.linkClicked.emit();
    }
}
